module.exports = __webpack_public_path__ + "img/boxgenerator_sample1.04755cfd.jpg";